/**
 * Every number that reaches the screen goes through here.
 *
 * JS float math leaks artifacts (0.1 + 0.2, 41.30000000000001), and raw
 * integers past four digits are unreadable without separators. Blocks must not
 * call toLocaleString / toFixed directly — route through this so rounding is
 * consistent across every visual.
 */
const DEFAULT_PERCENT_DP = 1;

export const formatMetric = (value, { unit = "", decimals } = {}) => {
  if (value == null || value === "" || Number.isNaN(Number(value))) return "—";
  const num = Number(value);

  if (unit === "%") {
    const dp = decimals == null ? DEFAULT_PERCENT_DP : decimals;
    // Drop a trailing .0 so "41.0%" reads as "41%".
    const rounded = Number(num.toFixed(dp));
    return `${rounded.toLocaleString(undefined, { maximumFractionDigits: dp })}%`;
  }

  if (unit === "currency") {
    return num.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: decimals == null ? 0 : decimals
    });
  }

  const dp = decimals == null ? (Number.isInteger(num) ? 0 : 1) : decimals;
  return num.toLocaleString(undefined, { maximumFractionDigits: dp });
};

/** Signed, formatted delta: "+12%", "-3.4", "0". */
export const formatDelta = (value, unit) => {
  if (value == null || Number.isNaN(Number(value))) return "";
  const num = Number(value);
  const sign = num > 0 ? "+" : "";
  return `${sign}${formatMetric(num, { unit })}`;
};

export default formatMetric;
